import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_close",
  "use": "svg_close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg_close\"><path d=\"M11.824 10.976a.6.6 0 1 1-.849.848L6 6.849l-4.976 4.977a.6.6 0 0 1-.849-.85L5.152 6 .175 1.024a.6.6 0 0 1 .85-.849L6 5.152 10.975.175a.6.6 0 0 1 .85.85L6.847 6l4.976 4.976Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol